import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { FieldConfig } from '../../_models/field.interface';
import * as alerts from '../../_functions/alerts';
import { Validators } from '@angular/forms';
import { Addrress, Attachments, Sac } from '../../_models/sac';
import { FileAux } from '../../_models/fileAux';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-atendimento-sac',
  templateUrl: './atendimento-sac.component.html',
  styleUrls: ['./atendimento-sac.component.scss'],
})
export class AtendimentoSacComponent implements OnInit {
  constructor(
    private location: Location,
    private authService: AuthService,
    private fidelidadeService: FidelidadeService,
    private sanitizer: DomSanitizer
  ) {}

  regConfigCadastroCacauLover: FieldConfig[] = [];
  regLabelMenuCacauLover: FieldConfig[] = [];

  mostrarCamposEcommerce: boolean = false;

  exibirLoader: boolean = false;

  ngOnInit(): void {
    this.registrarElementos();
  }

  carregarFormularioLogado() {
    this.fidelidadeService.LocalStorage.currentUserToken.subscribe(
      (value: any) => {
        if (value !== null) {
          this.fidelidadeService.obterMembro().subscribe(
            (res: any) => this.sucessoCarregarFormularioLogado(res),
            (err: any) => this.falhaCarregarFormularioLogado(err)
          );
        }
      }
    );
  }

  sucessoCarregarFormularioLogado(membro: any) {
    let nomeArr = membro.nome.split(' ');
    const nome = nomeArr[0];
    this.regConfigCadastroCacauLover[1].value = nome;

    nomeArr = nomeArr.slice(1, nomeArr.lenght);
    const sobrenome = nomeArr.join(' ');
    this.regConfigCadastroCacauLover[3].value = sobrenome;

    this.regConfigCadastroCacauLover[5].value = membro.email;

    const telefoneSemDDI = membro.telefone.substring(2, membro.telefone.lenght);
    this.regConfigCadastroCacauLover[7].value = telefoneSemDDI;

    this.regConfigCadastroCacauLover[9].value = membro.cpf;
  }

  falhaCarregarFormularioLogado(err: any) {
    console.error('Ocorreu um erro ao carregar o membro', err);
  }

  registrarElementos(): void {
    var input: object = {
      width: '98%',
      height: '184px',
      'background-color': '#EEE9DD',
      'margin-bottom': '-0.50em',
      'padding-left': '15px',
      'padding-top': '10px',
      'border-radius': '9px',
    };

    var inputTextBox: object = {
      width: '98%',
      height: '33px',
      'background-color': '#EEE9DD',
      'margin-bottom': '-0.50em',
    };

    var label: object = {
      'font-family': 'Sagona',
      'font-style': 'normal',
      'font-weight': '700',
      'font-size': '12px',
      color: '#512111',
      height: '0px',
      float: 'left',
      'letter-spacing:': '-0.01em',
      'white-space': 'pre-line',
    };

    this.regLabelMenuCacauLover = [
      {
        type: 'labelImage',
        label: 'Atendimento SAC',
        icon: ['assets/images/icons/voltar.png'],
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '24px',
            color: '#461F1A',
            'letter-spacing:': '-0.01em',
            'white-space': 'pre-line',
            height: '0px',
            'padding-left': '2rem',
            'padding-top': '1.6rem',
          };
        },
        onClick: () => {
          this.location.back();
        },
      },
    ];

    this.regConfigCadastroCacauLover = [
      {
        type: 'label',
        label: '<span class="text-danger">*</span>Nome',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        name: 'nome',
        maxSize: 100,
        value: '',
        styleDivPrincipal(): object {
          return { width: '310px', height: 'auto' };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^[a-zA-Z][a-zA-Z\\s]+$'),
            message: 'Nome deve conter apenas letras',
          },
        ],
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>Sobrenome',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        name: 'sobrenome',
        maxSize: 100,
        value: '',
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^[a-zA-Z][a-zA-Z\\s]+$'),
            message: 'Sobrenome deve conter apenas letras',
          },
        ],
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>E-mail',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'email',
        name: 'email',
        maxSize: 300,
        value: '',
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern(
              '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'
            ),
            message: 'E-mail Inválido',
          },
        ],
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>Telefone',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        inputmode: 'numeric',
        name: 'celular',
        mask: '(00) 00000-0000',
        value: '',
        maxSize: 16,
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^(\\+\\d{1,3}[- ]?)?\\d{11}$'),
            message: 'Telefone Inválido',
          },
        ],
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>CPF',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        inputmode: 'numeric',
        name: 'cpf',
        mask: '000.000.000-00',
        label: '___.___.___-__',
        value: '',
        styleDivPrincipal(): object {
          return {
            width: '300px',
          };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^\\d{11}$'),
            message: 'CPF Inválido',
          },
        ],
      },
      {
        type: 'label',
        label:
          '<span class="text-danger">*</span>Sobre o que gostaria de falar?',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'select',
        name: 'assunto',
        options: [
          'Informação E-commerce',
          'Elogio E-commerce',
          'Reclamação de produto adquirido no E-commerce',
          'Solicitação E-commerce',
          'Sugestões de E-commerce',
          'Reclamação de Atendimento de Loja física',
          'Sugestão para Loja Física',
          'Informação sobre Loja Física',
          'Reclamação de produto adquirido na Loja Física',
          'Elogio Loja Física',
          'Solicitação outros',
          'Reclamação - outros',
        ],
        styleDivPrincipal(): object {
          return { width: '320px', 'margin-left': '5px' };
        },
        style(): object {
          return {
            width: '100%',
            height: '33px',
            'background-color': '#EEE9DD',
            'border-radius': '500px',
            color: 'black',
            padding: '10px',
          };
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
        ],
        change: (event) => {
          if (event.value.includes('E-commerce')) {
            this.habilitarCamposEcommerce(true);
          } else {
            this.habilitarCamposEcommerce(false);
          }
        },
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>Número do pedido',
        visible: false,
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        name: 'numeroPedido',
        maxSize: 100,
        visible: false,
        value: '',
        styleDivPrincipal(): object {
          return { width: '270px' };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>Data do pedido',
        visible: false,
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        inputmode: 'numeric',
        name: 'dataPedido',
        mask: '00/00/0000',
        maxSize: 100,
        visible: false,
        value: '',
        styleDivPrincipal(): object {
          return { width: '270px' };
        },
        style(): object {
          return inputTextBox;
        },
        onClick() {
          return;
        },
      },
      {
        type: 'label',
        label: '<span class="text-danger">*</span>Conte-nos a sua história...',
        style(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'textArea',
        name: 'mensagem',
        class: 'cs-input',
        maxSize: 300,
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
      },
      {
        type: 'uploadFilesGeneric',
        name: 'uploadFiles',
        arquivos: [],
        selectFiles: (event) => {
          this.selectFiles(event);
        },
        removerArquivo: (arquivo) => {
          this.removerArquivo(arquivo);
        },
        transform: (base64, tipo) => {
          return this.transform(base64, tipo);
        },
      },
      {
        type: 'checkbox',
        label:
          'Estou ciente e aceito os termos javascript:abrirTermosPoliticaPrivacidade() da política de privacidade da Cacau Show',
        name: 'aceitaTermosPoliticaPrivacidade',
        class: 'checkbox_termos_privacidade',
        value: false,
        styleLabelCheckBox(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'checkbox',
        label:
          'Estou ciente e aceito que os meus dados, fornecidos neste formulário, sejam utilizados apenas com a finalidade de me identificar e retornar o contato',
        name: 'aceiteEnvioDados',
        class: 'checkbox_dados',
        value: false,
        styleLabelCheckBox(): object {
          return label;
        },
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            width: '300px',
            'margin-left': '5px',
          };
        },
        onClick(): void {},
      },
      {
        type: 'buttonSubmit',
        label: 'Enviar mensagem',
        style(): object {
          return {
            'background-color': '#461F1A',
            color: '#F4B241',
            'font-weight': 'bold',
            padding: '8px 20px 8px 20px',
          };
        },
      },
    ];
    this.carregarFormularioLogado();
  }

  submit(value: any) {
    if (this.mostrarCamposEcommerce) {
      if (
        value.assunto != 'Informação E-commerce' &&
        value.assunto != 'Elogio E-commerce' &&
        value.assunto != 'Sugestões de E-commerce'
      ) {
        if (value.numeroPedido == '') {
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'O campo <strong>Número do pedido</strong> deve ser preenchido!',
            'center',
            6000
          );
        }

        if (value.dataPedido == '') {
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'O campo <strong>Data do pedido</strong> deve ser preenchido!',
            'center',
            6000
          );
        }
      }
    }

    if (!value.mensagem)
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'O campo <strong>Mensagem</strong> deve ser preenchido, por favor escreva seu texto e tente novamente!',
        'center',
        6000
      );

    if (!value.aceitaTermosPoliticaPrivacidade)
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'Para o envio é necessário aceitar os termos da política de privacidade',
        'center',
        6000
      );

    if (!value.aceiteEnvioDados)
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'Para o envio é necessário aceitar o envio dos dados',
        'center',
        6000
      );

    var sac: Sac = new Sac();

    sac.name = value.nome;
    sac.lastName = value.sobrenome;

    if (value.dataPedido != '')
      sac.extenalOrderDate =
        value.dataPedido.substr(4, 4) +
        value.dataPedido.substr(2, 2) +
        value.dataPedido.substr(0, 2);

    sac.extenalOrderReference = value.numeroPedido;
    sac.addrress = new Addrress();
    sac.addrress.phone = value.celular;
    sac.addrress.email = value.email;
    sac.text = value.mensagem;
    sac.cpf = value.cpf;

    switch (value.assunto) {
      case 'Informação E-commerce': {
        sac.typeProcess = 'YEIN';
        break;
      }
      case 'Elogio E-commerce': {
        sac.typeProcess = 'YELE';
        break;
      }
      case 'Reclamação de produto adquirido no E-commerce': {
        sac.typeProcess = 'YERC';
        break;
      }
      case 'Solicitação E-commerce': {
        sac.typeProcess = 'YESO';
        break;
      }
      case 'Sugestões de E-commerce': {
        sac.typeProcess = 'YESU';
        break;
      }
      case 'Reclamação de Atendimento de Loja física': {
        sac.typeProcess = 'YREA';
        break;
      }
      case 'Sugestão para Loja Física': {
        sac.typeProcess = 'YSUG';
        break;
      }
      case 'Informação sobre Loja Física': {
        sac.typeProcess = 'YINF';
        break;
      }
      case 'Reclamação de produto adquirido na Loja Física': {
        sac.typeProcess = 'YREC';
        break;
      }
      case 'Elogio Loja Física': {
        sac.typeProcess = 'YELO';
        break;
      }
      case 'Solicitação outros': {
        sac.typeProcess = 'YSOL';
        break;
      }
      case 'Reclamação - outros': {
        sac.typeProcess = 'YREP';
        break;
      }
      default: {
        break;
      }
    }

    for (
      let index = 0;
      index < this.regConfigCadastroCacauLover.length;
      index++
    ) {
      if (
        this.regConfigCadastroCacauLover[index].type == 'uploadFilesGeneric'
      ) {
        if (
          this.regConfigCadastroCacauLover[index].arquivos != null &&
          this.regConfigCadastroCacauLover[index].arquivos != undefined &&
          this.regConfigCadastroCacauLover[index].arquivos.length > 0
        ) {
          sac.attachments = [];
          for (
            let i = 0;
            i < this.regConfigCadastroCacauLover[index].arquivos.length;
            i++
          ) {
            var anexo = new Attachments();
            anexo.type =
              this.regConfigCadastroCacauLover[index].arquivos[i].tipoArquivo;
            anexo.name =
              this.regConfigCadastroCacauLover[index].arquivos[i].nome;
            anexo.content =
              this.regConfigCadastroCacauLover[index].arquivos[i].base64;

            sac.attachments.push(anexo);
          }
        }
      }
    }

    this.exibirLoader = true;

    this.authService.getIPAddress().subscribe(
      (res) => {
        sac.ip = res.ip;
        this.fidelidadeService.abrirChamadoCRM(sac).subscribe(
          (res) => {
            this.processarSucesso(res);
          },
          (fail) => {
            this.processarFalha(fail);
          }
        );
      },
      (fail) => {
        this.processarFalha(fail);
      }
    );
  }

  habilitarCamposEcommerce(habilita: boolean) {
    this.mostrarCamposEcommerce = habilita;

    this.regConfigCadastroCacauLover[12].visible = habilita;
    this.regConfigCadastroCacauLover[13].visible = habilita;
    this.regConfigCadastroCacauLover[14].visible = habilita;
    this.regConfigCadastroCacauLover[15].visible = habilita;
  }

  processarSucesso(res: any): void {
    this.exibirLoader = false;

    this.regConfigCadastroCacauLover = [
      {
        type: 'label',
        label:
          'O Formulário foi enviado com sucesso! Anote seu número de protocolo para consultas futuras junto ao SAC: ' +
          res.resultado,
        styleDivPrincipal(): object {
          return {
            display: 'flex',
            'min-height': '350px',
            'margin-top': '150px',
            'margin-left': '5px',
          };
        },
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '700',
            'font-size': '20px',
            color: '#512111',
            height: '0px',
            float: 'left',
            'letter-spacing:': '-0.01em',
            'white-space': 'pre-line',
          };
        },
        onClick(): void {},
      },
    ];
  }

  processarFalha(fail: any): void {
    this.exibirLoader = false;
    alerts.exibirToast('danger', 'Falha ao enviar o e-mail, tente mais tarde.');
  }

  //#region Upload de arquivos

  selectFiles(event): void {
    for (let index = 0; index < event.target.files.length; index++) {
      const arquivo = event.target.files[index];

      if (this.validarArquivo(arquivo)) {
        this.readBase64(arquivo).then((data) => {
          var fileAux: FileAux = new FileAux();

          fileAux.nome = arquivo.name;
          fileAux.tipoArquivo = arquivo.type;
          fileAux.base64 = data;

          for (
            let index = 0;
            index < this.regConfigCadastroCacauLover.length;
            index++
          ) {
            if (
              this.regConfigCadastroCacauLover[index].type ==
              'uploadFilesGeneric'
            ) {
              this.regConfigCadastroCacauLover[index].arquivos.push(fileAux);
            }
          }
        });
      }
    }
  }

  validarArquivo(arquivo: File): boolean {
    if (
      arquivo.type != 'image/png' &&
      arquivo.type != 'image/jpeg' &&
      arquivo.type != 'application/pdf'
    ) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Apenas arquivos de imagens no formato jpeg ou png ou arquivos PDF são aceitos',
        icon: 'warning',
        confirmButtonColor: '#2d1708',
        confirmButtonText: 'Ok',
      }).then();
      {
        return;
      }
    }

    for (
      let index = 0;
      index < this.regConfigCadastroCacauLover.length;
      index++
    ) {
      if (
        this.regConfigCadastroCacauLover[index].type == 'uploadFilesGeneric'
      ) {
        if (this.regConfigCadastroCacauLover[index].arquivos.length > 2) {
          Swal.fire({
            title: 'Atenção!',
            text: 'É possível enviar somente 3 arquivos em anexo no chamado',
            icon: 'warning',
            confirmButtonColor: '#2d1708',
            confirmButtonText: 'Ok',
          }).then();
          {
            return;
          }
        }
      }
    }

    return true;
  }

  transform(base64: string, tipo: string) {
    if (tipo != 'application/pdf') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(base64);
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        './assets/images/others/icon_pdf.jpg'
      );
    }
  }

  removerArquivo(arquivo) {
    for (
      let index = 0;
      index < this.regConfigCadastroCacauLover.length;
      index++
    ) {
      if (
        this.regConfigCadastroCacauLover[index].type == 'uploadFilesGeneric'
      ) {
        this.regConfigCadastroCacauLover[index].arquivos =
          this.regConfigCadastroCacauLover[index].arquivos.filter(function (a) {
            return a.nome != arquivo.nome;
          });

        const fileUpload = document.getElementById(
          'file-upload'
        ) as HTMLInputElement;
        for (let i = 0; i < fileUpload.files.length; i++) {
          if (fileUpload.files[i].name == arquivo.nome) {
            fileUpload.value = null;
          }
        }
      }
    }
  }

  private readBase64(file): Promise<any> {
    if (file.size / 1024 / 1024 > 3) {
      Swal.fire({
        title: 'Atenção!',
        text: 'O arquivo deve ter o tamanho máximo de 3 megas!',
        icon: 'warning',
        confirmButtonColor: '#2d1708',
        confirmButtonText: 'Ok',
      }).then();
      {
        return;
      }
    } else {
      const reader = new FileReader();
      const future = new Promise((resolve, reject) => {
        reader.addEventListener(
          'load',
          function () {
            resolve(reader.result);
          },
          false
        );
        reader.addEventListener(
          'error',
          function (event) {
            reject(event);
          },
          false
        );

        reader.readAsDataURL(file);
      });
      return future;
    }
  }

  //#endregion
}
